import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { inject, observer } from "mobx-react/index";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { formatNullableValue } from '../../../utils/formatar';
import { IconeSetaDireita, IconeSetaDescer } from '../../comum/components/Icones'
import PopupOpenIcone from '../../comum/components/PopupOpenIcone'
import { Row, Col } from "reactstrap";

@inject("store")
@observer
export default class CardDetalheMobile extends Component {
    constructor(props) {
        super(props);
        this.dimensaoColuna = this.props.titulo2 ? 6 : 12;
    }

    renderColuna = (titulo, descricao, formatacao) => {
        return (
            <Col xl={this.dimensaoColuna} lg={this.dimensaoColuna} md={this.dimensaoColuna}>
                <span style={{display: 'flex'}}>
                    {titulo ? <h5>{titulo}{this.props.label && ` - ${this.props.label}`}</h5> : <h5>{this.props.label && `${this.props.label}`}</h5>}
                    {this.props.hasPopUp && <PopupOpenIcone className="card-detalhe-mobile--pop-icon" />}
                </span>
                {descricao && (
                    (titulo == "Containers")
                        ? <Link to={{
                            pathname: `/containers-detalhes/${descricao}`,
                            state: {
                                codigoContainer: descricao,
                                operacaoBooking: this.props.operacaoBooking,
                                codigoBooking: this.props.booking,
                                entradaCntr: this.props.entradaCntr
                            }
                        }}>{descricao}</Link>
                        : descricao &&
                        <div className="desc2">
                            {formatacao ?
                                formatNullableValue(formatacao(descricao))
                                :
                                (descricao == 2 ?
                                    <div>
                                        {descricao[0]}
                                        <span className="de-para"> > </span>
                                        {descricao[1]}
                                    </div>
                                    :
                                    formatNullableValue(typeof (descricao) === "string" ? descricao : descricao.join(''))
                                )
                            }
                        </div>
                )}
            </Col>);
    }

    render() {
        return (
            <div style={{padding: '5px'}}>
                <div className={`${this.props.onClick ? "card-detalhe--clickable" : ""} ${this.props.pt ? this.props.pt : ""} ${this.props.pb ? this.props.pb : ""}`} onClick={this.props.onClick}>
                    {this.props.icone && <span className="icone">{this.props.icone}</span>}
                    <div className="card-detalhe--conteudo">
                        <Row>
                            {this.renderColuna(this.props.titulo, this.props.desc, this.props.formatacao)}
                            {this.props.titulo2 && this.renderColuna(this.props.titulo2, this.props.desc2, this.props.formatacao2)}
                        </Row>
                    </div>
                </div>
            </div>)
    }
}


// WEBPACK FOOTER //
// ./src/modules/programacao/components/CardDetalheMobile.js